import { useRef, useState } from 'react';
import {
  Add as AddIcon,
  ArrowDropDown as ArrowDropDownIcon,
  ArrowDropUp as ArrowDropUpIcon,
} from '@mui/icons-material';
import { Button, ButtonGroup} from '@mui/material';
import { Grid } from '@mui/system';
import clsx from 'clsx';
import { classes, StyledGrid } from './FloatingButtonGroup.styles';
import FloatingButtonOptions from './FloatingButtonOptions';
import { Action, FloatingButtonGroupProps } from './types';

const FloatingButtonGroup = ({
  mainAction,
  secondaryActions = [],
  alignItems = 'flex-end',
  notFixed,
  ...rest
}: FloatingButtonGroupProps) => {
  const [isOpenSubMenu, setIsOpenSubMenu] = useState<boolean>(false);
  const openOptionsButtonRef = useRef<HTMLDivElement | null>(null);

  const getArrowIcon = () =>
    isOpenSubMenu ? <ArrowDropUpIcon id="comp-groups-up" /> : <ArrowDropDownIcon id="comp-groups-down" />;

  const handleToggle = () => {
    setIsOpenSubMenu(prevOpen => !prevOpen);
  };

  const getIcon = (action: Action) => {
    const Icon = action.icon || AddIcon;
    return <Icon className={classes.icon} fontSize="small" />;
  };

  return (
    <StyledGrid container>
      <Grid size={12} container direction="column" alignItems={alignItems}>
        <ButtonGroup
          color="primary"
          variant="outlined"
          aria-label="split button"
          className={notFixed ? classes.buttonGroup : clsx(classes.buttonGroup, classes.button)}
          ref={openOptionsButtonRef}
          {...rest}>
          <Button
            id="main-action-button"
            onClick={mainAction.onClick}
            style={{
              borderBottomLeftRadius: '2.688rem',
              borderTopLeftRadius: '2.688rem',
            }}>
            {getIcon(mainAction)}
            <span className={classes.label}>{mainAction.label}</span>
          </Button>
          <FloatingButtonOptions
            optionsMenu={secondaryActions}
            openOptionsButtonRef={openOptionsButtonRef}
            isOpenSubMenu={isOpenSubMenu}
            setIsOpenSubMenu={setIsOpenSubMenu}
            getIcon={getIcon}
          />
          <Button
            id="open-options-button"
            size="small"
            aria-controls={isOpenSubMenu ? 'split-button-menu' : undefined}
            aria-expanded={isOpenSubMenu ? 'true' : undefined}
            aria-label="floating button options"
            aria-haspopup="menu"
            onClick={handleToggle}
            style={{
              borderBottomRightRadius: '2.688rem',
              borderTopRightRadius: '2.688rem',
            }}>
            {getArrowIcon()}
          </Button>
        </ButtonGroup>
      </Grid>
    </StyledGrid>
  );
};

export default FloatingButtonGroup;
